module.exports = __webpack_public_path__ + "static/media/eh.9429f863.svg";